import {
  FETCH_PRACTICE_REQUEST,
  FETCH_PRACTICE_SUCCESS,
  FETCH_PRACTICE_ERROR
} from "./actions";
import { REDUCERS } from "../../common/constants";
import { createReducer } from "../../common/helpers";

const schema = {
  loading: false,
  error: false,
  totalElements: 0,
  practiceList: [],
  practiceDetail: {
    loading: false,
    error: false,
  },
};

const reducer = {
  // Program Options
  [FETCH_PRACTICE_REQUEST]: (state) => {
    return {
      ...state,
      ...REDUCERS.LOADING,
    };
  },
  [FETCH_PRACTICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      ...REDUCERS.SUCCESS,
      totalElements: payload.totalElements,
      practiceList: payload.content,
    };
  },
  [FETCH_PRACTICE_ERROR]: (state) => ({
    ...state,
    ...REDUCERS.ERROR,
    totalElements: 0,
    practiceList: []
  })
};

export default createReducer(schema, reducer);
